import {USER_LOGIN_FAILED, USER_LOGIN_SUCCESS} from "./userAction";

const initState = {
    currentUser: null,
    isAuthenticated: false,
}

const userReducer = (state = initState, action) =>{
    switch (action.type) {
        case USER_LOGIN_SUCCESS: {
            return {
                isAuthenticated: true,
                currentUser: action.currentUser
            }
        }
        case USER_LOGIN_FAILED: {
            return {
                isAuthenticated: false,
                currentUser: null
            }
        }
        default: return state;
    }
}

export default userReducer